import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { BackdropCircular, Breadcrumb } from 'components';
import { Card, SvgIcon, Checkbox, IconButton, Icon, TextField, Button } from '@material-ui/core';
import { TreeView, TreeItem } from '@material-ui/lab';
import { getStoreCategoriesTreeApi, saveStoreCategoryApi } from 'api';
import { changeStoreCategory, cancelAllStoreCategoriesChanges } from 'redux/actions/categories';


function MinusSquare(props) {
  return (
    <SvgIcon fontSize="inherit" style={{ width: 18, height: 18 }} {...props}>
      {/* tslint:disable-next-line: max-line-length */}
      <path d="M22.047 22.074v0 0-20.147 0h-20.12v0 20.147 0h20.12zM22.047 24h-20.12q-.803 0-1.365-.562t-.562-1.365v-20.147q0-.776.562-1.351t1.365-.575h20.147q.776 0 1.351.575t.575 1.351v20.147q0 .803-.575 1.365t-1.378.562v0zM17.873 11.023h-11.826q-.375 0-.669.281t-.294.682v0q0 .401.294 .682t.669.281h11.826q.375 0 .669-.281t.294-.682v0q0-.401-.294-.682t-.669-.281z" />
    </SvgIcon>
  );
}

function PlusSquare(props) {
  return (
    <SvgIcon fontSize="inherit" style={{ width: 18, height: 18 }} {...props}>
      {/* tslint:disable-next-line: max-line-length */}
      <path d="M22.047 22.074v0 0-20.147 0h-20.12v0 20.147 0h20.12zM22.047 24h-20.12q-.803 0-1.365-.562t-.562-1.365v-20.147q0-.776.562-1.351t1.365-.575h20.147q.776 0 1.351.575t.575 1.351v20.147q0 .803-.575 1.365t-1.378.562v0zM17.873 12.977h-4.923v4.896q0 .401-.281.682t-.682.281v0q-.375 0-.669-.281t-.294-.682v-4.896h-4.923q-.401 0-.682-.294t-.281-.669v0q0-.401.281-.682t.682-.281h4.923v-4.896q0-.401.294-.682t.669-.281v0q.401 0 .682.281t.281.682v4.896h4.923q.401 0 .682.281t.281.682v0q0 .375-.281.669t-.682.294z" />
    </SvgIcon>
  );
}

const Categories = () => {
  const dispatch = useDispatch();

  const [activeCategoryId, setActiveCategoryId] = useState('');
  const [isEditItemName, setIsEditItemName] = useState(false);
  const [categoryName, setCategoryName] = useState('');

  const {
    storeCategoriesTree,
    loadingStoreCategoriesTree,
    updatedStoreCategories,
    loadingSaveStoreCategories
  } = useSelector((state) => state.categories);

  useEffect(() => {
    if (storeCategoriesTree.length === 0) {
      getStoreCategoriesTreeApi({dispatch});
    }
  }, []);

  const handleChangeCategory = (event, categoryId, name) => {
    const {checked} = event.target;

    name === 'is_active' ?
      dispatch(changeStoreCategory(categoryId, name, checked))
      : dispatch(changeStoreCategory(categoryId, name, categoryName));
  };

  const handleSaveCategoriesChanges = async () => {
    if (Object.keys(updatedStoreCategories).length !== 0) {
      const categoriesPromises = Object.values(updatedStoreCategories).map((category) => {
        return saveStoreCategoryApi({dispatch, category});
      });
      await Promise.allSettled(categoriesPromises);
    }
  };

  const handleCancelAllChanges = () => dispatch(cancelAllStoreCategoriesChanges());

  const itemNameTextField = (id) => (
    <>
      <TextField
        variant="outlined"
        name="name"
        value={categoryName}
        onClick={(event) => event.stopPropagation()}
        onChange={(event) => {
          setCategoryName(event.target.value);
          event.stopPropagation();
          event.preventDefault();
        }}
      />
      <Button
        onClick={(event) => {
          setIsEditItemName(false);
          event.stopPropagation();
          event.preventDefault();
        }}
      >
        Cancel
      </Button>
      <Button
        color="primary"
        onClick={(e) => handleChangeCategory(e, id, 'name')}
      >
        Save
      </Button>
    </>
  );

  const renderTree = (nodes) => (
    <TreeItem
      key={nodes.id}
      nodeId={String(nodes.id)}
      className="p-1"
      onLabelClick={(event) => {
        setActiveCategoryId(nodes.id);
        setIsEditItemName(false);
        event.stopPropagation();
        event.preventDefault();
      }}
      label={
        <div className={`flex items-center ${nodes.is_active ? '' : 'text-muted'}`}>
          <Checkbox
            color="primary"
            checked={nodes.is_active}
            onChange={(e) => handleChangeCategory(e, nodes.id, 'is_active')}
            onClick={(e) => e.stopPropagation()}
          />
          {isEditItemName && activeCategoryId === nodes.id ?
            itemNameTextField(nodes.id)
            :
            <>
              <span>{nodes.name}</span>
              <span className="pl-2" title="Count of products in category">{`(${nodes.product_count})`}</span>
            </>
          }
          {activeCategoryId === nodes.id && !isEditItemName ?
            <IconButton
              title="Edit Category Name"
              className="justify-self-end"
              onClick={(event) => {
                setIsEditItemName(true);
                setCategoryName(nodes.name);
                event.stopPropagation();
                event.preventDefault();
              }}
            >
              <Icon>edit</Icon>
            </IconButton>
            : null
          }
        </div>
      }
    >
      {Array.isArray(nodes.children_data) ? nodes.children_data.map((node) => renderTree(node)) : null}
    </TreeItem>
  );

  return (
    <div className="flex-grow h-full min-h-full-screen scroll-y px-10 pb-25">
      <div className="mb-sm-30">
        <Breadcrumb
          routeSegments={[
            { name: 'Catalog' },
            { name: 'Categories' }
          ]}
        />
      </div>
      <Card elevation={25} className="p-10">
        <div className="flex justify-end items-center">
          <Button onClick={handleCancelAllChanges}>Cancel</Button>
          <Button
            variant="contained"
            color="primary"
            className="ml-2"
            onClick={handleSaveCategoriesChanges}
          >
            Save Changes
          </Button>
        </div>
        {storeCategoriesTree.length !== 0 &&
          <TreeView
            defaultExpanded={['2']}
            defaultCollapseIcon={<MinusSquare />}
            defaultExpandIcon={<PlusSquare />}
          >
            {renderTree(storeCategoriesTree[0])}
          </TreeView>
        }
      </Card>
      <BackdropCircular loading={loadingStoreCategoriesTree || loadingSaveStoreCategories} />
    </div>
  );
};

export default Categories;
